import { h, render } from 'preact';
import './header.css';

export default (element, data) => {
  const transparentHeader = () => {
    if (!data.isTransparent) return;
    const header = element.querySelector('[data-main-header]');

    window.onscroll = () => {
      if (document.documentElement.scrollTop > 56) {
        header.classList.remove('header--transparent');
      } else {
        header.classList.add('header--transparent');
      }
    };
  };

  const checkForPromoBar = () => {
    const promoBar = document.querySelector('.promo-bar');
    const header = document.querySelector('.header');
    if (!promoBar) {
      header.classList.remove('top-[35px]');
      header.classList.add('top-[0px]');
    }
  };

  const openSearch = () => {
    document.querySelectorAll('[data-open-search]').forEach((element) => {
      element.addEventListener('click', () => {
        const searchBox = document.getElementById('searchBox');
        searchBox.classList.remove('hidden');
        searchBox.querySelector('input').focus();
      });
    });
  };

  const closeSearch = () => {
    window.addEventListener('click', (e) => {
      if (
        !document.querySelector('[data-section="header"]').contains(e.target)
      ) {
        document.getElementById('searchBox').classList.add('hidden');
      }
    });
  };

  const hamburgerMenu = () => {
    const hamburgerIcon = document.querySelector('.hamburger-icon');
    const menu = document.querySelector('.hamburger-menu');
    const overlay = document.querySelector('.overlay');
    const closeIcon = document.querySelector('.hamburger-menu__close-icon');
    const body = document.querySelector('body');

    hamburgerIcon.addEventListener('click', () => {
      if (menu.classList.contains('slide-out')) {
        menu.classList.remove('slide-out');
        menu.classList.add('slide-in');
        closeIcon.classList.remove('hidden');
      }
      body.classList.add('overflow-hidden');
      overlay?.classList.remove('hidden');
    });

    document.addEventListener('click', function (e) {
      if (e.target.classList.contains('overlay')) {
        menu.classList.remove('slide-in');
        menu.classList.add('slide-out');
        closeIcon.classList.add('hidden');
        body.classList.remove('overflow-hidden');

        setTimeout(() => {
          overlay?.classList.add('hidden');
        }, '200');
      }
    });

    closeIcon.addEventListener('click', () => {
      menu.classList.remove('slide-in');
      menu.classList.add('slide-out');
      closeIcon.classList.add('hidden');
      body.classList.remove('overflow-hidden');

      setTimeout(() => {
        overlay?.classList.add('hidden');
      }, '200');
    });
  };

  const megaMenuDropdowns = () => {
    let mainHamburgerLinks = document.querySelectorAll('.main-hamburger-link');
    mainHamburgerLinks.forEach((link) => {
      let childLinks = link.nextElementSibling;
      let icon = link.querySelector('span');
      if (childLinks?.classList.contains('child')) {
        link?.addEventListener('click', () => {
          if (childLinks?.classList.contains('hidden')) {
            childLinks.classList.remove('hidden');
            link.classList.add('pb-[30px]');
            link.classList.remove('pb-[40px]');
            icon.classList.remove('rotate-180');
          } else {
            childLinks?.classList.add('hidden');
            link.classList.remove('pb-[30px]');
            link.classList.add('pb-[40px]');
            icon.classList.add('rotate-180');
          }
        });
        let childLink = childLinks?.querySelectorAll('.child-link');
        childLink?.forEach((singleLink) => {
          singleLink?.addEventListener('click', () => {
            let plusIcon = singleLink?.querySelector('.plus-icon');
            let minusIcon = singleLink?.querySelector('.minus-icon');
            let grandChild = singleLink?.querySelector('.grandchild');
            if (grandChild.classList.contains('hidden')) {
              grandChild.classList.remove('hidden');
              plusIcon.classList.add('hidden');
              minusIcon.classList.remove('hidden');
            } else {
              grandChild.classList.add('hidden');
              plusIcon.classList.remove('hidden');
              minusIcon.classList.add('hidden');
            }
          });
        });
      }
    });
  };

  const megaMenuDesktop = () => {
    const width = document.documentElement.clientWidth;
    if (width < 992 || !data.isTransparent) return false;

    const mainMenuLinks = document.querySelectorAll('.main-menu-link');
    const megaMenu = document.querySelector('.mega-menu');
    const body = document.querySelector('body');
    mainMenuLinks.forEach((link) => {
      link.onmouseover = () => {
        if (link.querySelector('.mega-menu')) {
          document
            .querySelector('[data-main-header]')
            .classList.remove('header--transparent');
        }
      };
      link.onmouseout = () => {
        if (document.documentElement.scrollTop < 35) {
          document
            .querySelector('[data-main-header]')
            ?.classList.add('header--transparent');
        }
      };
    });
  };

  transparentHeader();
  checkForPromoBar();
  openSearch();
  closeSearch();
  hamburgerMenu();
  megaMenuDropdowns();
  megaMenuDesktop();
};
